import React from "react";
import { Controller } from "react-hook-form";
import { Input } from "@components/atoms";
import { MemoFormProps } from "../types";
import { Keyboard } from "react-native";

const MemoForm: React.FC<MemoFormProps> = ({
  memoForm,
  t,
  sendValues,
  theme,
  testIDPrefix = "bmh.memoForm",
}) => {
  const { watch } = memoForm;
  const memoCommentsValue = watch("memoComments");

  return (
    <Controller
      control={memoForm.control}
      render={({
        field: { onChange, onBlur, value },
        formState: { errors },
      }) => (
        <Input
          testID={`${testIDPrefix}.input.memoComments`}
          inputLabel={t("bmh.input.comments.placeHolder.text")}
          placeholder={t("bmh.input.comments.placeHolder.text")}
          leftIcon={undefined}
          hideIconContainer={true}
          onBlur={onBlur}
          onChangeText={(val) => {
            onChange(val);
            sendValues();
          }}
          value={value || (memoCommentsValue ? memoCommentsValue : "")}
          error={(errors?.memoComments?.message ?? "") as string}
          multiline={true}
          {...(!theme.isLargeScreen && {
            blurOnSubmit: true,
            onSubmitEditing: () => {
              Keyboard.dismiss();
            },
          })}
          keyboardType="default"
          returnKeyType="done"
        />
      )}
      name="memoComments"
    />
  );
};

export default MemoForm;
